// Sound volume and alert duration are currently not adjustable in the settings as per requirements
export const SOUND_VOLUME = 0.9
export const DURATION = 5
export const DONATION_AMOUNT_ANIMATION_LENGTH = 1500
export const GIF_HEIGHT = 100

export const milestonesDemoData = [
  {
    id: 'demo-1',
    amountInCents: 100000,
    gifUrl: 'https://storage.googleapis.com/betterplace-download/alert_pin001.gif',
    soundUrl: 'https://storage.googleapis.com/betterplace-download/alert_pin001.mp3',
  },
  {
    id: 'demo-2',
    amountInCents: 150000,
    gifUrl: 'https://storage.googleapis.com/betterplace-download/alert_pin001.gif',
    soundUrl: null,
  },
  {
    id: 'demo-3',
    amountInCents: 250000,
    gifUrl: 'https://storage.googleapis.com/betterplace-download/alert_pin001.gif',
    soundUrl: 'https://storage.googleapis.com/betterplace-download/alert_pin001.mp3',
  },
  {
    id: 'demo-4',
    amountInCents: 300000,
    gifUrl:
      'https://media.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3cnMxMXcwOWRteDZiZXA4NWZreG83d2J4aHdyaTEydWJwc292dnZvaiZlcD12MV9naWZzX3JlbGF0ZWQmY3Q9Zw/d1FKToydnlo5YvhS/giphy.gif',
    soundUrl: null,
  },
]

export const emptyMilestone = {
  id: '',
  amountInCents: 0,
  gifUrl: null,
  soundUrl: null,
}
